<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="800">
    <template v-slot:title>{{ title }}</template>
    <v-tabs v-model="tab" centered>
      <v-tab key="details">Details</v-tab>
      <v-tab key="payment-terms">Payment Terms</v-tab>
      <v-tab-item key="details">
        <v-row>
          <v-col>
            <v-text-field
              label="Name"
              v-model="name"
              :outlined="outlinedInputs"
              hide-details
            />
          </v-col>
          <v-col sm="4">
            <v-text-field
              label="Code"
              v-model="code"
              :outlined="outlinedInputs"
              hide-details
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <taxes-list-select
              :tax-type="taxType"
              :outlined="outlinedInputs"
              hide-details
              @onSelectTaxType="onTaxSelect"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Sales Nominal Code"
              v-model="salesNominalCode"
              :outlined="outlinedInputs"
              hide-details
            />
          </v-col>
          <v-col sm="6">
            <v-text-field
              label="Purchase Nominal Code"
              v-model="purchaseNominalCode"
              :outlined="outlinedInputs"
              hide-details
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-switch label="Not In Use" v-model="notInUse" />
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item key="payment-terms">
        <payment-terms
          v-if="value && value.id"
          :owner-id="value.id"
          v-model="paymentTerms"
        />
      </v-tab-item>
    </v-tabs>

    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <div v-if="debug">
      <code>
        {{ paymentTerms }}
      </code>
    </div>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
import PaymentTerms from "../../shared/payment-terms/PaymentTerms.vue";
import TaxesListSelect from "../../shared/TaxesListSelect.vue";
export default {
  components: { BasicDialog, TaxesListSelect, PaymentTerms },

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      debug: false,
      tab: null,
      name: this.value ? this.value.name : "New Department",
      taxType: this.value ? this.value.taxType : "",
      notInUse: this.value ? this.value.notInUse : false,
      salesNominalCode: this.value ? this.value.salesNominalCode : "",
      purchaseNominalCode: this.value ? this.value.purchaseNominalCode : "",
      code: this.value ? this.value.code : "",
      paymentTerms: this.value ? this.value.paymentTerms : [],
    };
  },

  computed: {
    isValid() {
      return this.name && this.name != "";
    },
    title() {
      return this.value && this.value.id ? this.name : "New Department";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.name = newVal.name;
        this.code = newVal.code;
        this.taxType = newVal.taxType;
        this.notInUse = newVal.notInUse;
        this.salesNominalCode = newVal.salesNominalCode;
        this.purchaseNominalCode = newVal.purchaseNominalCode;
        this.paymentTerms = [...newVal.paymentTerms];
      } else {
        this.paymentTerms = [];
      }
    },
  },

  methods: {
    onTaxSelect(payload) {
      this.taxType = payload.description;
    },
    onSave() {
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        name: this.name,
        code: this.code,
        taxType: this.taxType,
        notInUse: this.notInUse,
        salesNominalCode: this.salesNominalCode,
        purchaseNominalCode: this.purchaseNominalCode,
        paymentTerms: this.paymentTerms,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/department-types/DepartmentEditDialog.vue